import React from 'react';
import { Grid, TextField, Autocomplete, Typography, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { bloodUnitTypes, transfusionReasons } from '../../constants/options';

const BloodTransfusionSection = ({ formData, handleChange }) => {
  const bloodCategories = [
    { label: "PRBC UNITS", name: "prbc_units", prefix: "prbc_units_" },
    { label: "FFP UNITS", name: "ffp_units", prefix: "ffp_units_" },
    { label: "PLATELETS UNITS", name: "platelets_units", prefix: "platelets_units_" },
    { label: "OTHER BLOOD UNITS", name: "other_blood_units", prefix: "other_blood_units_" },
  ];

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 7: Blood Units & Transfusion
      </Typography>
      
      <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
        <Table size="small">
          <TableBody>
            {bloodCategories.map((cat) => (
              <TableRow key={cat.name}>
                <TableCell sx={{ fontWeight: 600, width: '200px' }}>{cat.label}</TableCell>
                {[1, 2, 3].map((i) => (
                  <TableCell key={i}>
                    <Autocomplete
                      freeSolo
                      size="small"
                      options={bloodUnitTypes}
                      value={formData[cat.name][`${cat.prefix}${i}`] || ''}
                      onChange={(_, newVal) => handleChange({ target: { name: `${cat.name}.${cat.prefix}${i}`, value: newVal } })}
                      renderInput={(params) => <TextField {...params} variant="standard" fullWidth />}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Grid container spacing={4} sx={{ mt: 2 }}>
        <Grid item xs={12} sm={4}>
           <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Blood Transfusion Given?</Typography>
           <FormControl component="fieldset">
            <RadioGroup row name="blood_transfusion" value={formData.blood_transfusion || 'No'} onChange={handleChange}>
              <FormControlLabel value="Yes" control={<Radio size="small" />} label="Yes" />
              <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
            </RadioGroup>
          </FormControl>
        </Grid>
        
        {formData.blood_transfusion === "Yes" && (
          <Grid item xs={12} sm={8}>
            <Autocomplete
                freeSolo
                options={transfusionReasons}
                value={formData.blood_transfusion_if_yes || ''}
                onChange={(_, newVal) => handleChange({ target: { name: "blood_transfusion_if_yes", value: newVal } })}
                renderInput={(params) => <TextField {...params} label="Specify Reason / Indication" fullWidth size="small" variant="outlined" />}
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default BloodTransfusionSection;
